import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/hook';
import { accessibilityProvider } from '../../store/providers/accessibilityProvider';
import { useEffect, useState } from 'react';

export const useDelayedFocus = (element: HTMLElement | null, delayTime: number): void => {
  const accessibility = useAppSelector((state) => state.accessibility);
  const { setAccessibility } = accessibilityProvider();
  const location = useLocation();
  const [isFocusTriggered, setFocusTriggered] = useState(false);

  useEffect(() => {
    if (accessibility.pageChanged) {
      const timeout = setTimeout(() => {
        setFocusTriggered(true);
      }, delayTime);
      return (): void => clearTimeout(timeout);
    }
  }, [accessibility.pageChanged, delayTime]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFocusTriggered(true);
    }, delayTime);
    return (): void => clearTimeout(timeout);
  }, [delayTime, location.pathname]);

  useEffect(() => {
    if (isFocusTriggered) {
      element?.focus({ preventScroll: true });
      setFocusTriggered(false);
      setAccessibility({ pageChanged: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocusTriggered, element]);
};
